export const VM = {
  3: 'Неверный адрес электронной почты',
  5: 'Укажите вашу фамилию и имя',
  6: 'Формат: Иванов Иван',
  7: 'Укажите номер телефона',
  9: 'Выберите уровень владения английским языком',
  12: 'Неверный формат телефона',
  13: 'Укажите адрес электронной почты',
  18: 'Укажите город проживания',
  23: 'Укажите дату рождения',
  27: 'Укажите корректный год рождения',
  29: 'Укажите имя пользователя в telegram',
  45: 'Выберите страну проживания',
  47: 'Допустимые символы: "Аа-Яя", "Ёё", "пробел", "-"',
  49: 'Укажите образование и годы обучения',
  50: 'Выберите, как вы узнали об ASTON',
  51: 'Укажите, как вы узнали об ASTON',
  52: 'Допустимые символы: "Аа-Яя", "Ёё", "Aa-Zz", "0-9", "пробел", "-"',
  64: 'Допустимые символы: "Aa-Zz", "0-9", "_"',
  113: 'Укажите название онлайн-школы',
};

// Флаг i у regExp означает поиск без зависимости от регистра
export const REG_EXP = {
  ruText_dash_space: /^[а-яё-\s]+$/i,
  ruEngText_numbers_dash_space: /^[а-яa-zё\d\s-]+$/i,

  firstLastName: /^[а-яё-]{1,58}\s[а-яё-]{1,58}$/i,
  email: /^[\w-][a-z\d_.-]{1,63}@[a-z\d-]{1,63}\.[a-z]{2,6}$/i,
  telegram: /^@?[a-z\d_]*$/i,
  date: /__.__.____|^(0[1-9]|[12][\d]|3[01])\.(0[1-9]|1[0-2])\.(19[4-9][\d]|20[01]\d|202[0-3])$/,
  phone: /^(\+7\d{10}|\+375\d{9})$/,
};
